// Membership-role presentation. Shared by the workspace switcher (Topbar) and
// the Settings page so the two never drift.

// Permission role → label. `full` reads "Managed" because a `full` membership
// to an archer that is *not* you means you fully manage someone else's archer.
export const ROLE_LABEL = {
  full: "Managed",
  score_on_behalf: "Scorer",
  read_only: "Viewer",
};

// Label for one membership entry ({ role, is_self }). The user's own archer is
// always "You"; everything else falls back to its permission role.
export function membershipLabel({ role, is_self }) {
  if (is_self) return "You";
  return ROLE_LABEL[role] ?? role;
}
